import { Alert, Form, Input, SpaceBetween } from "@cloudscape-design/components";
import Button from "@cloudscape-design/components/button";
import Modal from "@cloudscape-design/components/modal";
import { mdiCheckboxMultipleOutline } from "@mdi/js";
import { Icon } from "@mdi/react";
import React, { useEffect, useState } from "react";
import { btnDanger, btnSuccess, btnWarn } from "../../resources/types";

export interface ConfirmDeleteProps {
    header?: React.ReactNode;
    subtitle?: React.ReactNode;
    show: boolean;
    confirmWord: string;
    action: string;
    warning: string;
    button?: 'info' | 'success' | 'warning' | 'danger';
    onConfirm?: () => void;
    onDismiss?: () => void;
}

export const ConfirmDelete: React.FC<ConfirmDeleteProps> = ({
    header,
    show,
    subtitle,
    confirmWord = 'eliminar',
    action = 'Eliminar',
    warning = '',
    button = 'error',
    onConfirm,
    onDismiss,
}) => {
    const [confirmWord2, setConfirmWord2] = useState("");
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        setConfirmWord2("");
    }, [show]);
    return (
        <Modal visible={show} size="medium" header={<><Icon path={mdiCheckboxMultipleOutline} size={1} /> {" "}{header}</>}
            onDismiss={() => {
                if (onDismiss) {
                    onDismiss();
                    show = false;
                }
            }}>
            <Form actions={<Button variant={button === "info" ? "primary" : "normal"} style={{ root: button === "danger" || button === "error" ? btnDanger : button === "warning" ? btnWarn : button === "success" ? btnSuccess : null }} disabled={confirmWord.toLowerCase() !== confirmWord2.toLowerCase()}
                onClick={() => {
                    if (onConfirm && onDismiss) {
                        show = false;
                        onDismiss();
                        onConfirm();
                    }
                }
                }>{action}</Button>}
                secondaryActions={<Button variant="link" onClick={() => {
                    if (onDismiss) {
                        show = false;
                        onDismiss();
                    }
                }}>Cancelar</Button>}
            >
                <SpaceBetween size="m" direction="vertical">
                    {subtitle !== "" && (
                        <div>
                            {subtitle}
                        </div>
                    )}
                    {warning !== "" && (
                        <Alert type="warning">
                            {warning}

                        </Alert>
                    )}
                    <div>
                        Para evitar acciones involuntarias, le solicitamos que proporcione un consentimiento adicional por escrito.
                    </div>

                    <SpaceBetween direction="vertical" size="xxs">
                        <strong>Para confirmar esta acción, escriba "<em>{confirmWord.toLowerCase()}</em>".</strong>

                        <SpaceBetween size="m" direction="horizontal">
                            <Input placeholder={confirmWord} value={confirmWord2} onChange={(event) => { setConfirmWord2(event.detail.value.toLowerCase()) }} />
                        </SpaceBetween>
                    </SpaceBetween>
                </SpaceBetween>
            </Form>
        </Modal >
    );
};

export default ConfirmDelete;
